import { GcfCommonComponentConfigInterface } from '../FormSelector.interface';

export interface IDisclaimerConfig
  extends Pick<GcfCommonComponentConfigInterface, 'scaleTypeKey'> {
  background: string;
  text: string;
  backgroundColor?: string;
  font?: string;
  color?: string;
  fontSize?: string;
  lineHeight?: string;
}

export const DisclaimerConfigSchema = {
  title: 'Disclaimer Component JSON Config',
  description: 'JSON Configuration Options for GCF Disclaimer Component',
  type: 'object',
  properties: {
    background: {
      type: 'string',
      minLength: 1,
    },
    backgroundColor: {
      type: 'string',
    },
    text: {
      type: 'string',
    },
    color: {
      type: 'string',
    },
    font: {
      type: 'string',
    },
    fontSize: {
      type: 'string',
    },
    scaleTypeKey: {
      type: 'string',
    },
  },
  required: ['background', 'text'],
  additionalProperties: true,
};
